if (!customElements.get('custom-select-donor')) {
  customElements.define('custom-select-donor', class CustomSelectDonor extends CustomSelect {
    constructor() {
      super();
      this.wrapperDiv.classList.add('custom-select-donor');
    }

    appendOptions() {
      this.optionsDiv.innerHTML = '';

      for (let index = 0; this.selectElement.options.length > index; index++) {
        const opt = this.selectElement.options[index];
        const option = document.createElement('div');
        option.classList.add('custom-select-option');
        opt.classList.forEach(cls => option.classList.add(cls));
        option.dataset.optionIndex = index;

        // Add image if available
        const image = opt.dataset.image;
        if (image && opt.value) {
          option.innerHTML = `<img src="${image}" alt="${opt.text}"><span>${opt.text}</span>`;
        } else {
          option.innerHTML = opt.innerHTML;
        }

        if (opt.disabled) {
          option.classList.add('disabled');
        }

        if (typeof opt.dataset.optionPlaceholder !== 'undefined') {
          option.classList.add('placeholder');
        }

        option.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();

          if (option.classList.contains('disabled')) return;

          this.close();
          this.selectElement.value = opt.value;
          this.dispatchEvent(new Event('input'));
          this.dispatchEvent(new Event('change'));
        });

        this.optionsDiv.append(option);
      }
    }

    update() {
      this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => option.classList.remove('selected'));

      const selectedIndex = this.selectElement.options.selectedIndex;
      const option = this.optionsDiv.querySelector(`[data-option-index="${selectedIndex}"]`);
      const selectedOption = this.selectElement.options[selectedIndex];

      if (option) {
        option.classList.add('selected');

        // Show image in value if available
        const image = selectedOption?.dataset?.image;
        if (image && selectedOption.value) {
          this.valueDiv.innerHTML = `<img src="${image}" alt="${selectedOption.text}"><span>${selectedOption.text}</span>`;
        } else {
          this.valueDiv.innerHTML = selectedOption?.text || '';
        }
      } else {
        this.valueDiv.innerHTML = '';
      }
    }

    getIcon() {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20.9999 21.0002L16.6599 16.6602" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    }
  });
}